"use strict";

var ipV4Regex = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
var IpV6OctateRegex = "[a-fA-F\\d]{1,4}";
var ipV6Regex = "\n(?:\n(?:".concat(IpV6OctateRegex, ":){7}(?:").concat(IpV6OctateRegex, "|:)|                                   \n(?:").concat(IpV6OctateRegex, ":){6}(?:").concat(ipV4Regex, "|:").concat(IpV6OctateRegex, "|:)|                             \n(?:").concat(IpV6OctateRegex, ":){5}(?::").concat(ipV4Regex, "|(?::").concat(IpV6OctateRegex, "){1,2}|:)|                   \n(?:").concat(IpV6OctateRegex, ":){4}(?:(?::").concat(IpV6OctateRegex, "){0,1}:").concat(ipV4Regex, "|(?::").concat(IpV6OctateRegex, "){1,3}|:)| \n(?:").concat(IpV6OctateRegex, ":){3}(?:(?::").concat(IpV6OctateRegex, "){0,2}:").concat(ipV4Regex, "|(?::").concat(IpV6OctateRegex, "){1,4}|:)| \n(?:").concat(IpV6OctateRegex, ":){2}(?:(?::").concat(IpV6OctateRegex, "){0,3}:").concat(ipV4Regex, "|(?::").concat(IpV6OctateRegex, "){1,5}|:)| \n(?:").concat(IpV6OctateRegex, ":){1}(?:(?::").concat(IpV6OctateRegex, "){0,4}:").concat(ipV4Regex, "|(?::").concat(IpV6OctateRegex, "){1,6}|:)| \n(?::(?:(?::").concat(IpV6OctateRegex, "){0,5}:").concat(ipV4Regex, "|(?::").concat(IpV6OctateRegex, "){1,7}|:))            \n)(?:%[0-9a-zA-Z]{1,})?                                            \n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
module.exports = {
  /**
   * Function to check if the address is valid IP address
   * @param {*} ipAddress
   * @returns true or false
   */
  isIPAddress: function isIPAddress(ipAddress) {
    return new RegExp("(?:^".concat(ipV4Regex, "$)|(?:^").concat(ipV6Regex, "$)")).test(ipAddress.toString());
  },

  /**
   * Function which validates ipV4 address
   * @param {*} ipV4Address
   * @returns true or false
   */
  isIPV4Address: function isIPV4Address(ipV4Address) {
    return new RegExp("^".concat(ipV4Regex, "$")).test(ipV4Address.toString());
  },

  /**
   * Function which validates ipV6 address
   * @param {*} ipV6Address
   * @returns true or false
   */
  isIPV6Address: function isIPV6Address(ipV6Address) {
    return new RegExp("^".concat(ipV6Regex, "$")).test(ipV6Address.toString());
  },

  /**
   * Function to return IP address version
   * @param {*} ipAddress
   * @returns version
   */
  ipVersion: function ipVersion(ipAddress) {
    return new RegExp("(?:^".concat(ipV4Regex, "$)|(?:^").concat(ipV6Regex, "$)")).test(ipAddress.toString()) ? new RegExp("^".concat(ipV6Regex, "$")).test(ipV6Address.toString()) ? 6 : 4 : "Please enter valid IP address";
  }
};